var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90099 3.59284C1.90099 3.32617 1.84818 3.12617 1.68977 2.92617L0.211221 0.659505V0.326172H4.80528L8.39604 10.2595L11.5644 0.326172H16V0.659505L14.7327 2.19284C14.6271 2.32617 14.5743 2.45951 14.5743 2.65951V13.9928C14.5743 14.1928 14.6271 14.3262 14.7327 14.4595L16 15.9928V16.3262H9.66337V15.9928L10.9307 14.3928C11.0363 14.2595 11.0363 14.1928 11.0363 13.9262V4.79284L7.44554 16.2595H6.9703L2.85149 4.79284V12.5262C2.79868 12.8595 2.90429 13.1928 3.06271 13.3928L4.75248 15.9928V16.3262H0V15.9928L1.68977 13.3928C1.84818 13.1262 1.9538 12.8595 1.90099 12.5262V3.59284Z",
    fill: "#777FEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.e3301a37b6cb1c432e0a23669ced7a58.svg";
export { ForwardRef as ReactComponent };